import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App.jsx';
import reportWebVitals from './reportWebVitals';
import './i18n';
import LogRocket from 'logrocket';
LogRocket.init('mvkb2z/battery-cloud-frontend');

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<div>Loading ...</div>}>
      <App />
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
